export const PROPERTY_FEATURES_STRINGS = {
  title: 'Any communal features in or around the property to inspect?',
  'not_first_time_saving.title':
    'Last time we asked about communal features, you told us about the following. Anything to change?',
  'other_features.title': 'Something else? Let us know!',
  'missing_features.placeholder': 'Missing Communal Features (OPTIONAL)',
};
